export const ACTIVE_REPAIR_STEP = 'active tracking';
export const APPOINTMENT_STEP = 'appointment';
export const CANCELED_REPAIR_STEP = 'canceled repair';
export const CANCELLATION_STEP = 'cancellation';
export const CONFIGURABLE_FIELDS_STEP = 'configurable fields';
export const RESCHEDULE_STEP = 'reschedule';
export const CART_STEP = 'cart';
export const COLOR_STEP = 'color';
export const CONTACT_STEP = 'contact';
export const DEVICE_BRAND_STEP = 'device brand';
export const DEVICE_MODEL_HELPER_STEP = 'device model helper';
export const DEVICE_MODEL_STEP = 'device model';
export const DEVICE_TYPE_STEP = 'device type';
export const ISSUE_STEP = 'issue';
export const LANDING_STEP = 'landing';
export const LOCATION_STEP = 'location';
export const ON_SITE_STEP = 'on site location';
export const IN_STORE_STEP = 'in store location';
export const STORE_LIST_STEP = 'store list';
export const PAYMENT_STEP = 'payment';
export const REPAIR_SUBMISSION_STEP = 'repair submission';
export const RESCHEDULE_APPOINTMENT_STEP = 'reschedule appointment';
export const REVIEW_STEP = 'review';
export const SERVICE_OPTION_STEP = 'select service option';
export const SUBMIT_STEP = 'submit';
export const CUSTOMER_DETAILS = 'customer details';
